import React, { type FC } from "react";

import type { OpenInterval } from "~/tools/date-time/open-interval";

import { useFormattedViewInterval } from "./useFormatViewInterval";

export interface FormatViewIntervalProps {
	interval: OpenInterval;
}

export const FormatViewInterval: FC<FormatViewIntervalProps> = ({ interval, ...restProps }) => {
	const formattedViewInterval = useFormattedViewInterval(interval);
	return <span {...restProps}>{formattedViewInterval.toString()}</span>;
};
